import { mixpanel } from '@fiverr-private/obs';

export const trackMixpanel = (component: string, eventName: string, properties: object) => {
    mixpanel.track(`Inspire - ${component} - ${eventName}`, properties);
};
